'use client';

/* eslint-disable react-refresh/only-export-components */

import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react';

export function getPaginationWindow(currentPage: number, totalPages: number): number[] {
  return Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
    if (totalPages <= 5) return i + 1;
    if (currentPage <= 3) return i + 1;
    if (currentPage >= totalPages - 2) return totalPages - 4 + i;
    return currentPage - 2 + i;
  });
}

interface Props {
  totalCount: number;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
}

export function TransactionPagination({
  totalCount,
  currentPage,
  pageSize,
  onPageChange,
}: Props) {
  const totalPages = Math.ceil(totalCount / pageSize);

  if (totalCount <= pageSize) return null;

  return (
    <div className="flex items-center justify-between gap-3 border-t border-border px-4 py-3 sm:px-5 sm:py-4">
      <p className="text-2xs font-semibold whitespace-nowrap text-text-tertiary sm:text-xs">
        <span className="hidden sm:inline">
          {((currentPage - 1) * pageSize) + 1}-{Math.min(currentPage * pageSize, totalCount)} de {totalCount}
        </span>
        <span className="sm:hidden">
          {currentPage} / {totalPages}
        </span>
      </p>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="rounded-lg p-2 transition-colors hover:bg-accent disabled:cursor-not-allowed disabled:opacity-30"
          aria-label="Página anterior"
        >
          <CaretLeftIcon size={16} className="text-text-secondary" />
        </button>
        <div className="hidden items-center gap-1 sm:flex">
          {getPaginationWindow(currentPage, totalPages).map((pageNum) => (
            <button
              key={pageNum}
              type="button"
              onClick={() => onPageChange(pageNum)}
              className={`w-8 h-8 rounded-lg text-xs font-bold transition-colors ${
                currentPage === pageNum
                  ? 'bg-primary text-primary-foreground'
                  : 'text-text-secondary hover:bg-accent'
              }`}
            >
              {pageNum}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className="rounded-lg p-2 transition-colors hover:bg-accent disabled:cursor-not-allowed disabled:opacity-30"
          aria-label="Próxima página"
        >
          <CaretRightIcon size={16} className="text-text-secondary" />
        </button>
      </div>
    </div>
  );
}
